<script>

export default {
  name: "SaleIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
  }
};

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none" role="img" aria-label="Ícone de vendas">
    <title>Ícone de vendas</title>
    <path
      d="M0.5 3.1L2.45 0.5H10.25L12.2 3.1M0.5 3.1V12.2C0.5 12.5448 0.636964 12.8754 0.880761 13.1192C1.12456 13.363 1.45522 13.5 1.8 13.5H10.9C11.2448 13.5 11.5754 13.363 11.8192 13.1192C12.063 12.8754 12.2 12.5448 12.2 12.2V3.1M0.5 3.1H12.2M8.95 5.7C8.95 6.38956 8.67607 7.05088 8.18848 7.53848C7.70088 8.02607 7.03956 8.3 6.35 8.3C5.66044 8.3 4.99912 8.02607 4.51152 7.53848C4.02393 7.05088 3.75 6.38956 3.75 5.7"
      :stroke="color" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>